import React, { useEffect } from 'react'
import { Box, Button, DialogActions, FormHelperText, FormLabel } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import ButtonSubmit from '../../common/ButtonSubmit'
import StripePaymentMethodElement from '../../checkout/StripePaymentMethodElement'
import { publishViewed } from '../../../util/events/teamsGiftsEventPublishers'
import { VIEWS } from '../../../util/events/teamsEvents'
import DialogContent from './DialogContent'
import { PROGRAM_DIALOG_HEIGHT } from './programUtils'

const StepAddPaymentMethod = ({
  CardElement,
  helperText = undefined,
  submitting,
  onBack,
  error = undefined,
}) => {
  useEffect(() => {
    publishViewed(VIEWS.STEP_GIFT_ADD_PAYMENT)
  }, [])

  return (
    <>
      <DialogContent height={PROGRAM_DIALOG_HEIGHT}>
        <FormLabel htmlFor="credit-card">Payment method</FormLabel>
        <Box marginTop={2}>
          <StripePaymentMethodElement id="credit-card" CardElement={CardElement} />
          {helperText && (
            <Box paddingTop={2}>
              <FormHelperText>{helperText}</FormHelperText>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack}>Back</Button>
        <ButtonSubmit color="primary" variant="contained" submitting={submitting}>
          Confirm
        </ButtonSubmit>
      </DialogActions>
      {error && <Alert color="error">{error}</Alert>}
    </>
  )
}

export default StepAddPaymentMethod
